export default __webpack_public_path__ + "bc797355a81a2563ad900d5e1d457cce.jpg";